import { supportChatId } from "@vidimo/shared";
import {
  type ConnectRefusalCode,
  ConnectRefusalCodeSchema,
} from "@vidimo/shared/contracts";
import type { GuestChat } from "@/lib/collections/guest-chats";
import { appRoutes } from "./routes";

/** Guest/staff/AI chat detail URLs in the flat Chats tab. */
export function chatPath(
  chat: Pick<GuestChat, "id">,
  highlight?: string
): string {
  const q = new URLSearchParams({ id: chat.id });
  if (highlight) {
    q.set("highlight", highlight);
  }
  const base = appRoutes.app.chats();
  return `${base}?${q}`;
}

/**
 * The Vidimo team conversation. `conversationId` names one conversation (a
 * reply's push carries it, and it may be for another property); without it the
 * address means "mine, for the property I am working in". `about` names a
 * connect the host could not finish, so the composer opens with a message
 * saying so; a code rather than text, since anyone can write an address.
 */
export function supportChatPath(
  conversationId?: string,
  about?: ConnectRefusalCode
): string {
  const path = chatPath({ id: supportChatId(conversationId) });
  return about ? `${path}&${new URLSearchParams({ about })}` : path;
}

/**
 * The Vidimo team chat on the draft a link's `about` names, or null for a code
 * this app does not know: the links that carry it come over public schemes.
 */
export function linkedSupportChatPath(about: unknown): string | null {
  const code = ConnectRefusalCodeSchema.safeParse(about);
  return code.success ? supportChatPath(undefined, code.data) : null;
}
